import Button from "../Form/Button/Button";
import React from "react";
import './text-styles.scss'
import close from "../../assets/images/close-dark-grey.svg";

function CloseButton(/** @type {{onClick: () => void;}} */ {onClick}) {    
    return <Button size='med' customClassNames={["button3__close"]} label={<div><p>Close <img className={"maturity3__inline-icon"} src={close}/></p></div>} onClick={onClick}/>
}

export default CloseButton